import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useProduct = (id) => useQuery({ queryKey: [`product`, id], queryFn: async () => {
    if(!id) return {}
    const callback = await API.get(`/store/products/${id}`)
    return callback?.data
}})

export default useProduct